module.exports = __webpack_public_path__ + "img/82.6.CODm.f59cb801.png";